const colors = {
  dark: "#040301",
  white: "#FCFCFC",
  lightGrey: "#F7F7F7",
  purple: "#36326F",
  pink: "#F3E9EA",
  overlay: "rgba(0, 0, 0, 0.4)",
};

export default colors;
